// extracted by mini-css-extract-plugin
module.exports = {"component":"SeoVehicleSearch_component__e0xzi","link":"SeoVehicleSearch_link__ll_gW"};